import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN } from "../../store/action";
import { dayPlusOne, todayDate } from "../functions/dateFunctions";
import "../styles/layout.css";

// image importation

import { configureCrisp } from "../../utils/crispConfig";
import PaniEmpowerment from "../elements/pani-empowerment";
import QandA from "../elements/q-and-a";
import SectionSignUp from "../elements/section-sign-up";
import SectionWorkingChef from "../elements/section-working-chef";
import TestitmonialChef from "../elements/testimonial-chef";
import WhatIsPani from "../elements/what-is-pani";
import WhyPani from "../elements/why-pani";

const LayoutBecome = () => {

  const [phone, setPhone] = useState("");
  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);

  const dispatch = useDispatch();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    if (!selectedWhen || selectedWhen <= todayDate()) {
      const tday = dayPlusOne();
      WhenDate(tday);
    }
  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        {/* Tu dois ajouter tout les autre compasant du projet ici */}
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              maxWidth: "2800px",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            {" "}
            {/*utilisation du maxwidth pour eviter des comportements inattendu avec les tailles des differents éléments (img, div etc) */}
            <PaniEmpowerment
              phone={phone}
              setPhone={(data) => setPhone(data)}
            />
            {/* <OpportunityPani /> */}
            <WhatIsPani />
            {/* <Certification /> */}
            <WhyPani />
            <SectionWorkingChef />
            <TestitmonialChef />
            <QandA />
            <SectionSignUp />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutBecome;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});
